import * as React from "react";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {faMap} from "@fortawesome/free-regular-svg-icons/faMap";
import {faMapMarker} from "@fortawesome/free-solid-svg-icons/faMapMarker";
import {faMapMarkedAlt} from "@fortawesome/free-solid-svg-icons/faMapMarkedAlt";
import {faMapMarkerAlt} from "@fortawesome/free-solid-svg-icons/faMapMarkerAlt";
import {faGoogle} from "@fortawesome/free-brands-svg-icons/faGoogle";
import {SpinnerButton} from "shared/controls/SpinnerButton";
import {faCheck} from "@fortawesome/free-solid-svg-icons/faCheck";
import {ToastService} from "shared/core/services/ToastService";
import {SettingsOptions} from "../SettingsOptions";
import Axios from "axios";
import {WpAjaxPost} from "shared/core/ajax/WPAjaxPost";
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";

export class General extends React.Component<GeneralProps, GeneralState> {
    static defaultProps: Partial<GeneralProps> = {};
    public DeleteMetricsBusy:boolean=false;

    constructor(props: GeneralProps) {
        super(props);
        this.state = {
            LicenseIsActive:this.props.Settings.LicenseKey!='',
            Processing:false
        };
    }

    public render() {
        return (
            <div>
                <div style={{backgroundColor:'white',padding:10}}>
                    <RNTextInput<SettingsOptions> Value={this.props.Settings.LicenseKey}  Label={'License Key'} onChange={x=>{this.props.Settings.LicenseKey=x.trim(); this.forceUpdate()}} disabled={this.state.LicenseIsActive} />
                    <SpinnerButton Icon={null} OnClick={()=>this.ToggleActivation()} disabled={this.props.Settings.LicenseKey==''} className={'rnbtn-primary'} IsBusy={this.state.Processing}>{this.state.LicenseIsActive?'Deactivate':'Activate'}</SpinnerButton>
                </div>

                <div style={{padding:10}}>
                    <SpinnerButton Icon={faTrash} IsBusy={this.DeleteMetricsBusy} OnClick={()=>this.DeleteMetrics()} className={'rnbtn rnbtn-danger'}>Delete font metrics folder</SpinnerButton>
                    <p style={{margin:0,fontStyle:'italic'}}>Do this if you are having issues with the text of your pdf that the plugin create, for example when you are seeing weird symbols or when the space between letters is too wide</p>
                </div>
            </div>
        )
    }

    private async ToggleActivation() {
        if(!this.state.LicenseIsActive)
            this.ActivateLicense();
        else
            this.DeactivateLicense();


    }


    private ActivateLicense() {
        this.setState({Processing:true});
        let licenseKey=this.props.Settings.LicenseKey;
        Axios.get(rnSettings.RootURL+`?edd_action=activate_license&item_id=${rnSettings.ItemId}&license=${this.props.Settings.LicenseKey}&url=${rnSettings.BaseUrl}`).then(async result=>{
            if(result.status!=200)
            {
                ToastService.SendErrorMessage('An unexpected error occurred, please try again');
                this.setState({Processing:false});
                return;
            }

            if (result.data.license!='valid') {
                this.setState({Processing:false});
                ToastService.SendErrorMessage('Invalid license!');
                return;
            }
            Axios.get(rnSettings.RootURL+`?edd_action=check_license&item_id=${rnSettings.ItemId}&license=${licenseKey}`).then(async result2=> {

                if(result2.status!=200)
                {
                    ToastService.SendErrorMessage('An unexpected error occurred, please try again');
                    this.setState({Processing:false});
                    return;
                }
                let expirationDate=new Date(result2.data.expires);
                if(isNaN(expirationDate as any))
                {
                    ToastService.SendErrorMessage('An unexpected error occurred, please try again');
                    this.setState({Processing:false});
                    return;
                }
                let result = await WpAjaxPost.Post('activate_license', {LicenseKey: licenseKey,ExpirationDate:expirationDate.getTime()/1000,URL:rnSettings.BaseUrl});
                this.setState({Processing: false});
                if (result == null)
                    return;

                this.props.Settings.LicenseKey = licenseKey;
                rnSettings.LicenseURL=rnSettings.BaseUrl;
                ToastService.SendSuccess('License activated successfully');
                this.setState({
                    Processing:false,
                    LicenseIsActive:true
                })
            });
        });
    }

    private DeactivateLicense() {
        this.setState({Processing: true});
        Axios.get(rnSettings.RootURL+`?edd_action=deactivate_license&item_id=${rnSettings.ItemId}&license=${this.props.Settings.LicenseKey}&url=${rnSettings.LicenseURL}`).then(async result=> {
            if (result.status != 200) {
                ToastService.SendErrorMessage('An unexpected error occurred, please try again');
                this.setState({Processing: false});
                return;
            }

            if (!result.data.success) {
                ToastService.SendErrorMessage('The license could not be deactivated! please try again');
                this.setState({Processing: false});
                return;
            }


            let result2 = await WpAjaxPost.Post('deactivate_license');
            this.setState({Processing: false});
            if (result2 == null)
                return;

            this.setState({LicenseIsActive:false});

            ToastService.SendSuccess('License deactivated successfully');

            rnSettings.LicenseURL='';
            this.props.Settings.LicenseKey='';
        });
    }

    private async DeleteMetrics() {
        this.DeleteMetricsBusy=true;
        this.forceUpdate();
        let result= await WpAjaxPost.Post('delete_metrics');
        this.DeleteMetricsBusy=false;
        this.forceUpdate();
        if(result==null)
            return;
        ToastService.SendSuccess('Metrics folder deleted successfully');
        this.forceUpdate();
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface GeneralProps {
    Settings:SettingsOptions;
}

interface GeneralState {
    LicenseIsActive:boolean;
    Processing:boolean;

}

//#endregion "My Region"